import {FinancialEditor} from "./RecordExpenses.jsx";
export default function CreateInvoice(props){return <FinancialEditor {...props} kind="invoice"/>;}
